import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCredits } from '../../contexts/CreditsContext';
import ModalPortal from '../common/ModalPortal';
import '../../styles/modals.css';
import './InsufficientCreditsModal.css';

const InsufficientCreditsModal = ({
  isOpen,
  onClose,
  requiredCredits = 0,
  currentCredits = 0,
  contentTitle = 'this content',
  contentType = 'content',
  onLoginRequired
}) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { creditBalance } = useCredits();

  // Use props or context for credit amounts
  const displayCurrentCredits = currentCredits || creditBalance;
  // const creditsNeeded = requiredCredits - displayCurrentCredits;
  const isEmptyBalance = displayCurrentCredits === 0;

  const handleBuyCredits = () => {
    onClose();
    // Redirect to credits page
    navigate('/credits', { state: { from: window.location.pathname } });
  };

  const handleClose = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
    <ModalPortal isOpen={isOpen}>
      <div
        className="insufficient-credits-overlay"
        onClick={handleClose}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div
          className="insufficient-credits-modal"
          onClick={(e) => e.stopPropagation()}
          tabIndex="-1"
        >
          <div className="credits-modal-header">
            <h2 id="modal-title">
              <span className="gold-icon">�</span>
              {isEmptyBalance ? 'EMPTY CREDIT BALANCE' : 'INSUFFICIENT CREDITS'}
            </h2>
            <button
              className="credits-close-button"
              onClick={onClose}
              aria-label="Close modal"
            >×</button>
          </div>

          <div className="credits-modal-content">
            <div className="credit-info">
              {isEmptyBalance ? (
                <p className="credits-message">
                  Your credit balance is empty. Purchase credits to access premium content.
                </p>
              ) : (
                <p className="credits-message">
                  You need <strong>{requiredCredits} credits</strong> to access {contentTitle}.
                </p>
              )}

              <div className="credit-pills-container">
                <div className="credit-pill your-credits">
                  <span className="pill-label">Your Credits</span>
                  <span className="pill-amount">{displayCurrentCredits}</span>
                </div>
                <div className="credit-pill required-credits">
                  <span className="pill-label">Required</span>
                  <span className="pill-amount">{requiredCredits}</span>
                </div>
              </div>
            </div>

            <div className="credit-pricing">
              <span className="pricing-badge">1 credit = 10p</span>
            </div>

            {!isAuthenticated && (
              <p className="auth-message">
                Sign up or log in to purchase credits and access premium content!
              </p>
            )}

            <div className="credits-modal-actions">
              {isAuthenticated ? (
                <button
                  className="credits-primary-btn"
                  onClick={handleBuyCredits}
                >
                  Get Started
                </button>
              ) : (
                <button
                  className="credits-primary-btn"
                  onClick={() => { onClose(); onLoginRequired && onLoginRequired(); }}
                >
                  Get Started
                </button>
              )}
              <button
                className="credits-secondary-btn"
                onClick={onClose}
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
    </>
  );
};

export default InsufficientCreditsModal;